


















import { Vue, Component, Prop } from "vue-property-decorator";
import {namespace} from "vuex-class";
import { sendVerificationSms, sendPhoneRegisterSms } from '@/services/loginManager';
import { replace } from 'ramda';
import { AxiosError } from "axios";
import { isErrorType } from '@/services/errorHandling';
import { DroppoErrors } from "@/constants/errors";

const userData = namespace("userData");

@Component({
  name: "ResendVerification",
  components: {
  },
})
export default class ResendVerification extends Vue {
  @Prop({default: ""})
  private phone!: string;

  @Prop()
  private message!: string;

  @Prop({default: false})
  private register!: boolean;

  private sendingSms: boolean = false;

  private close() {
    this.$emit("dialog:clickClose");
  }

  private sendLink() {
    const myPhone: string = replace(/ /g, '', this.phone);
    this.sendingSms = true;
    const sendSms = this.register ? sendPhoneRegisterSms : sendVerificationSms;

    sendSms(myPhone)
      .then(() => this.$uiBus.emit("genericMessage:show", this.$t('registerForm.resendVerificationSuccess')))
      .catch(this.showErrors)
      .finally(() => {
        this.sendingSms = false;
        this.close();
      });
  }

  private showErrors(err: AxiosError) {
    if (isErrorType(DroppoErrors.DAILY_VALIDATION_SMS_LIMIT_REACH, err)) {
      this.$uiBus.emit("genericError:show", this.$t('errors.contact'));
    } else if (isErrorType(DroppoErrors.SYSTEM_MINUTE_VALIDATION_SMS_LIMIT_REACH, err)) {
      this.$uiBus.emit("genericError:show", this.$t('errors.smsLimitReach'));
    } else {
      this.$uiBus.emit("genericError:show", this.$t('errors.unknown'));
    }
  }
}
